import { initializeHeader } from "./header";
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { startLoadingDisplay, endLoadingDisplay } from "../modules/uiManager/UiLoadingDisplay";
import { showPopupAlert, showPopupConfirm } from "../modules/uiManager/UiPopup";
import { populateSelect, isCodeMasterLoaded, fetchCodeMaster, setCodeMaster } from "../modules/codeMasterManager/CodeMasterManager";
import { openCandidateSearch, openStoreSearch, openEmployeeSearch, openVendorSearch } from "../modules/searchModal/SearchModalConfigs";
import { fetchFieldSurveyRequestDetail, fetchFieldSurveyRequestStatus, updateFieldSurveyRequest, cancelFieldSurveyRequest, getApiErrorMessage } from "../apis/fieldSurveyRequestApi";
import { fetchOperationPermissions } from "../apis/graphqlClient";
import { getOperationPermission, setOperationPermissions, isOperationPermissionsLoaded } from "../modules/permissionManager/PermissionManager";
import { loadMockZoData, loadMockDoData, getAllZone, getAllDo } from "../data/zodoData";
function toJstDateString(dateStr) {
    if (!dateStr)
        return '';
    const normalized = dateStr.replace(/\//g, '-').replace(' ', 'T') + (dateStr.includes('Z') || dateStr.includes('+') ? '' : 'Z');
    const d = new Date(normalized);
    if (isNaN(d.getTime()))
        return dateStr;
    const jst = new Date(d.getTime() + 9 * 60 * 60 * 1000);
    const y = jst.getUTCFullYear();
    const m = String(jst.getUTCMonth() + 1).padStart(2, '0');
    const day = String(jst.getUTCDate()).padStart(2, '0');
    const hh = String(jst.getUTCHours()).padStart(2, '0');
    const mm = String(jst.getUTCMinutes()).padStart(2, '0');
    const ss = String(jst.getUTCSeconds()).padStart(2, '0');
    return `${y}/${m}/${day} ${hh}:${mm}:${ss}`;
}
const STORE_SEARCH_ENABLED_TYPES = ['020', '030', '031', '032'];
const PARKING_EXPANSION_TYPES = ['030', '031', '032'];
let documentRows = [];
let allDocumentRows = [];
let currentDetail = null;
function updateStoreSearchState(handlingType) {
    const btn = document.getElementById('btnStoreSearch');
    if (btn) {
        btn.disabled = true;
        btn.style.opacity = '0.5';
    }
    const input = document.getElementById('txtStoreNo');
    const enabled = STORE_SEARCH_ENABLED_TYPES.includes(handlingType);
    if (input) {
        input.disabled = !enabled;
        if (!enabled) {
            input.classList.add('form-input-disabled');
        }
        else {
            input.classList.remove('form-input-disabled');
        }
    }
}
function updateRequiredMarks(handlingType) {
    const isParkingType = PARKING_EXPANSION_TYPES.includes(handlingType);
    const isStoreEnabled = STORE_SEARCH_ENABLED_TYPES.includes(handlingType);
    const candidateLabel = document.getElementById('txtCandidateId')?.parentElement?.previousElementSibling;
    const storeLabel = document.getElementById('txtStoreNo')?.parentElement?.previousElementSibling;
    if (candidateLabel) {
        candidateLabel.classList.toggle('required', !isParkingType && !!handlingType);
    }
    if (storeLabel) {
        storeLabel.classList.toggle('required', isStoreEnabled);
    }
}
function onHandlingTypeChange(handlingType) {
    updateStoreSearchState(handlingType);
    updateRequiredMarks(handlingType);
    documentRows = [...allDocumentRows];
    renderDocumentTable();
}
function setupHandlingTypeControl() {
    const sel = document.getElementById('selHandlingType');
    if (!sel)
        return;
    sel.addEventListener('change', () => onHandlingTypeChange(sel.value));
    updateStoreSearchState(sel.value);
    updateRequiredMarks(sel.value);
}
function populateZoSelect() {
    const sel = document.getElementById('selZO');
    if (!sel)
        return;
    const zone = getAllZone();
    let html = '<option value="">-- 選択 --</option>';
    for (const key in zone.zone_data) {
        const z = zone.zone_data[key];
        html += `<option value="${z.zone_code}">${z.zone_name}</option>`;
    }
    sel.innerHTML = html;
}
function populateDoSelect() {
    const sel = document.getElementById('selDO');
    if (!sel)
        return;
    const doInfo = getAllDo();
    let html = '<option value="">-- 選択 --</option>';
    for (const key in doInfo.do_data) {
        const d = doInfo.do_data[key];
        html += `<option value="${d.do_code}">${d.do_name}</option>`;
    }
    sel.innerHTML = html;
}
function initializeFormSelects() {
    populateSelect('selHandlingType', 'handling_type', '選択してください');
    populateSelect('selPrefecture', 'prefecture', '選択してください');
    populateSelect('selContractType', 'contract_type', '選択してください');
    populateSelect('selOwnership', 'ownership_type', '選択してください');
    populateSelect('selBuildingType', 'building_type', '選択してください');
    populateSelect('selLicense', 'license_plan', '選択してください');
    populateSelect('selSubmissionMethod', 'submission_method', '選択してください');
    populateZoSelect();
    populateDoSelect();
}
function escapeHtml(str) {
    if (!str)
        return '';
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}
function toDateInputValue(dateStr) {
    if (!dateStr)
        return '';
    return dateStr.replace(/\//g, '-');
}
function populateForm(data) {
    const setVal = (id, val) => {
        const el = document.getElementById(id);
        if (el)
            el.value = String(val ?? '');
    };
    setVal('lblStatus', data.statusName);
    setVal('lblInternalId', data.internalId);
    setVal('lblRequestCount', data.requestCount);
    setVal('lblRequestDate', data.requestDate);
    setVal('selHandlingType', data.handlingTypeCode);
    setVal('txtCandidateId', data.candidateId);
    setVal('txtStoreNo', data.storeNo);
    setVal('txtStoreName', data.storeName);
    setVal('txtStoreNameKana', data.storeNameKana);
    setVal('selPrefecture', data.prefectureCode);
    setVal('selZO', data.zo);
    setVal('selDO', data.do);
    setVal('txtAddress', data.address);
    setVal('selContractType', data.contractTypeCode);
    setVal('selBuildingType', data.buildingTypeCode);
    setVal('selLicense', data.licenseCode);
    setVal('dtOpenDate', toDateInputValue(data.openDate));
    setVal('dtSurveyDesiredDate', toDateInputValue(data.surveyDesiredDate));
    setVal('dtReportDueDate', toDateInputValue(data.reportDueDate));
    setVal('selSubmissionMethod', data.submissionMethodCode);
    setVal('selOwnership', data.ownershipCode);
    setVal('txtRemarks', data.remarks);
    const chk = document.getElementById('chkConfirmation');
    if (chk)
        chk.checked = !!data.confirmation;
    setVal('txtRequesterCode', data.requesterCode);
    setVal('txtRequester', data.requesterName);
    setVal('txtApproverCode', data.approverCode);
    setVal('txtApprover', data.approverName);
    setVal('txtDmCode', data.dmCode);
    setVal('txtDm', data.dmName);
    setVal('txtDesignOfficeCode', data.designOfficeCode);
    setVal('txtDesignOffice', data.designOfficeName);
    setVal('txtRetryReason', data.retryReason);
    setVal('txtApprovalDept', data.approvalDept);
    setVal('txtApprovalArch', data.approvalArch);
}
function renderDocumentTable() {
    const tbody = document.getElementById('documentTableBody');
    if (!tbody)
        return;
    let html = '';
    documentRows.forEach((row) => {
        html += `
      <tr>
        <td><span>${escapeHtml(row.documentName)}</span></td>
        <td>${escapeHtml(row.fileName)}</td>
        <td>${escapeHtml(row.uploader)}</td>
        <td>${escapeHtml(row.uploadDate)}</td>
        <td>
          <button type="button" class="pill-button-outline" disabled style="padding: 4px 12px; font-size: 12px; opacity: 0.5;">
            <span class="material-icons" style="font-size: 14px;">upload_file</span>選択
          </button>
        </td>
        <td>
          ${row.fileName
            ? `<button type="button" disabled style="background:none;border:none;color:#999;opacity:0.5;">
                <span class="material-icons">delete</span>
              </button>`
            : ''}
        </td>
      </tr>
    `;
    });
    tbody.innerHTML = html;
}
function validateForm() {
    const handlingType = document.getElementById('selHandlingType')?.value || '';
    const isStoreEnabled = STORE_SEARCH_ENABLED_TYPES.includes(handlingType);
    const isParkingType = PARKING_EXPANSION_TYPES.includes(handlingType);
    const requiredFields = [
        { id: 'selHandlingType', name: '取扱区分' },
        ...(!isParkingType ? [{ id: 'txtCandidateId', name: '候補地番号' }] : []),
        ...(isStoreEnabled ? [{ id: 'txtStoreNo', name: '店番' }] : []),
        { id: 'txtStoreName', name: '店名' },
        { id: 'selPrefecture', name: '都道府県' },
        { id: 'selZO', name: 'ZO' },
        { id: 'selDO', name: 'DO' },
        { id: 'selContractType', name: '契約タイプ' },
        { id: 'selOwnership', name: '契約形態(所有区分)' },
        { id: 'selBuildingType', name: '建物種類' },
        { id: 'dtOpenDate', name: '開店予定日' },
        { id: 'dtSurveyDesiredDate', name: '現地調査希望日' },
        { id: 'dtReportDueDate', name: '現地調査報告書提出予定日' },
        { id: 'selSubmissionMethod', name: '提出方法' },
        { id: 'txtRemarks', name: '備考' },
        { id: 'txtRequester', name: '依頼者' },
        { id: 'txtApprover', name: '部門承認者' },
        { id: 'txtDm', name: 'DM' },
    ];
    const emptyFields = [];
    let hasError = false;
    requiredFields.forEach(({ id, name }) => {
        const el = document.getElementById(id);
        if (el) {
            const value = el.value.trim();
            if (!value) {
                el.style.borderColor = '#d32f2f';
                emptyFields.push(name);
                hasError = true;
            }
            else {
                el.style.borderColor = '';
            }
        }
    });
    const chk = document.getElementById('chkConfirmation');
    if (chk && !chk.checked) {
        emptyFields.push('確認事項');
        hasError = true;
    }
    if (hasError) {
        showPopupAlert({ text: `必須項目を入力してください。（${emptyFields.join('、')}）`, showBackdrop: true });
        return false;
    }
    const formatRules = [
        { id: 'txtCandidateId', name: '候補地番号', pattern: /^[a-zA-Z0-9]*$/, format: '半角英数字' },
        { id: 'txtStoreNo', name: '店番', pattern: /^[0-9]*$/, format: '半角数字' },
        { id: 'txtStoreName', name: '店名', pattern: /^[^\x20-\x7E]*$/, format: '全角' },
        { id: 'txtStoreNameKana', name: '店名カナ', pattern: /^[^\x20-\x7E]*$/, format: '全角' },
    ];
    const formatErrors = [];
    formatRules.forEach(({ id, name, pattern, format }) => {
        const el = document.getElementById(id);
        if (el && el.value && !el.disabled && !pattern.test(el.value)) {
            el.style.borderColor = '#d32f2f';
            formatErrors.push(`${name}(${format})`);
        }
    });
    if (formatErrors.length > 0) {
        showPopupAlert({ text: `入力形式が不適切です。（${formatErrors.join('、')}）`, showBackdrop: true });
        return false;
    }
    return true;
}
function collectFormData() {
    const getVal = (id) => {
        const el = document.getElementById(id);
        return el ? el.value.trim() : '';
    };
    const chk = document.getElementById('chkConfirmation');
    return {
        internalId: getVal('lblInternalId'),
        handlingType: getVal('selHandlingType'),
        candidateId: getVal('txtCandidateId'),
        storeNo: getVal('txtStoreNo'),
        storeName: getVal('txtStoreName'),
        storeNameKana: getVal('txtStoreNameKana'),
        prefecture: getVal('selPrefecture'),
        zo: getVal('selZO'),
        do: getVal('selDO'),
        address: getVal('txtAddress'),
        contractType: getVal('selContractType'),
        ownership: getVal('selOwnership'),
        buildingType: getVal('selBuildingType'),
        license: getVal('selLicense'),
        openDate: getVal('dtOpenDate'),
        surveyDesiredDate: getVal('dtSurveyDesiredDate'),
        reportDueDate: getVal('dtReportDueDate'),
        submissionMethod: getVal('selSubmissionMethod'),
        confirmation: chk ? chk.checked : false,
        retryReason: getVal('txtRetryReason'),
        remarks: getVal('txtRemarks'),
        requesterCode: getVal('txtRequesterCode'),
        approverCode: getVal('txtApproverCode'),
        dmCode: getVal('txtDmCode'),
        designOfficeCode: getVal('txtDesignOfficeCode'),
    };
}
function setupButtons() {
    const btnBack = document.getElementById('btnBack');
    if (btnBack) {
        btnBack.addEventListener('click', (e) => {
            e.preventDefault();
            showPopupConfirm({
                text: '一覧画面に戻りますか。入力内容はクリアされます。',
                showBackdrop: true,
                onConfirm: () => navigate('/field-survey-request-list')
            });
        });
    }
    const btnRequest = document.getElementById('btnRequest');
    if (btnRequest) {
        btnRequest.addEventListener('click', () => {
            if (!validateForm())
                return;
            showPopupConfirm({
                text: '依頼を行いますか。',
                showBackdrop: true,
                onConfirm: async () => {
                    try {
                        startLoadingDisplay();
                        if (currentDetail) {
                            const current = await fetchFieldSurveyRequestStatus(currentDetail.internalId);
                            if (current.statusCode !== currentDetail.statusCode) {
                                endLoadingDisplay();
                                showPopupAlert({ text: 'ステータスが変更されました。\n一覧画面で再検索してください。', showBackdrop: true });
                                return;
                            }
                        }
                        await updateFieldSurveyRequest(collectFormData());
                        endLoadingDisplay();
                        showPopupAlert({ text: '現地調査依頼が完了しました。', showBackdrop: true, onClose: () => navigate('/field-survey-request-list') });
                    }
                    catch (error) {
                        endLoadingDisplay();
                        console.error('依頼更新に失敗:', error);
                        showPopupAlert({ text: getApiErrorMessage(error, '依頼の更新に失敗しました。しばらく時間をおいて再度お試しください。'), showBackdrop: true });
                    }
                }
            });
        });
    }
    const btnCancel = document.getElementById('btnCancel');
    if (btnCancel) {
        btnCancel.addEventListener('click', () => {
            showPopupConfirm({
                text: '中止しますか。',
                showBackdrop: true,
                onConfirm: async () => {
                    try {
                        startLoadingDisplay();
                        const internalId = document.getElementById('lblInternalId')?.value || '';
                        if (currentDetail) {
                            const current = await fetchFieldSurveyRequestStatus(currentDetail.internalId);
                            if (current.statusCode !== currentDetail.statusCode) {
                                endLoadingDisplay();
                                showPopupAlert({ text: 'ステータスが変更されました。\n一覧画面で再検索してください。', showBackdrop: true });
                                return;
                            }
                        }
                        await cancelFieldSurveyRequest({ internalId });
                        endLoadingDisplay();
                        showPopupAlert({ text: '現地調査依頼を中止しました。', showBackdrop: true, onClose: () => navigate('/field-survey-request-list') });
                    }
                    catch (error) {
                        endLoadingDisplay();
                        console.error('依頼中止に失敗:', error);
                        showPopupAlert({ text: getApiErrorMessage(error, '依頼の中止に失敗しました。しばらく時間をおいて再度お試しください。'), showBackdrop: true });
                    }
                }
            });
        });
    }
    const btnCandidateSearch = document.getElementById('btnCandidateSearch');
    if (btnCandidateSearch) {
        btnCandidateSearch.addEventListener('click', () => openCandidateSearch());
    }
    const btnStoreSearch = document.getElementById('btnStoreSearch');
    if (btnStoreSearch) {
        btnStoreSearch.addEventListener('click', () => openStoreSearch());
    }
    const btnRequesterSearch = document.getElementById('btnRequesterSearch');
    if (btnRequesterSearch) {
        btnRequesterSearch.addEventListener('click', () => openEmployeeSearch('txtRequester', 'txtRequesterCode', 'REQUESTER'));
    }
    const btnApproverSearch = document.getElementById('btnApproverSearch');
    if (btnApproverSearch) {
        btnApproverSearch.addEventListener('click', () => openEmployeeSearch('txtApprover', 'txtApproverCode', 'APPROVER'));
    }
    const btnDmSearch = document.getElementById('btnDmSearch');
    if (btnDmSearch) {
        btnDmSearch.addEventListener('click', () => openEmployeeSearch('txtDm', 'txtDmCode', 'DM'));
    }
    const btnDesignOfficeSearch = document.getElementById('btnDesignOfficeSearch');
    if (btnDesignOfficeSearch) {
        btnDesignOfficeSearch.addEventListener('click', () => openVendorSearch('txtDesignOffice', 'txtDesignOfficeCode'));
    }
}
export const initializeFieldSurveyRequestEdit = async (requestId) => {
    try {
        startLoadingDisplay();
        const content = await getHtml('/parts/fieldSurveyRequestEdit.html');
        const subContents = document.getElementById('subContents');
        if (content && subContents) {
            subContents.innerHTML = content;
        }
        await initializeHeader('現地調査依頼');
        if (!isOperationPermissionsLoaded()) {
            const ops = await fetchOperationPermissions();
            setOperationPermissions(ops);
        }
        const op = getOperationPermission('SITE_SURVEY');
        if (op && !op.ssRevision) {
            endLoadingDisplay();
            await showPopupAlert({ text: '差戻修正の権限がありません。', showBackdrop: true });
            navigate('/fieldSurveyRequest');
            return;
        }
        if (!isCodeMasterLoaded()) {
            const codeMaster = await fetchCodeMaster();
            setCodeMaster(codeMaster);
        }
        await Promise.all([loadMockZoData(), loadMockDoData()]);
        initializeFormSelects();
        if (requestId) {
            currentDetail = await fetchFieldSurveyRequestDetail(requestId);
            populateForm(currentDetail);
            if (currentDetail.documents && currentDetail.documents.length > 0) {
                allDocumentRows = currentDetail.documents.map(d => ({
                    documentName: d.documentName,
                    fileName: d.fileName,
                    uploader: d.uploader,
                    uploadDate: toJstDateString(d.uploadDate),
                }));
            }
            else {
                allDocumentRows = [];
            }
            documentRows = [...allDocumentRows];
            renderDocumentTable();
        }
        const txtCandidateId = document.getElementById('txtCandidateId');
        if (txtCandidateId) {
            txtCandidateId.disabled = true;
            txtCandidateId.classList.add('form-input-disabled');
        }
        const btnCandidateSearchEl = document.getElementById('btnCandidateSearch');
        if (btnCandidateSearchEl) {
            btnCandidateSearchEl.disabled = true;
            btnCandidateSearchEl.style.opacity = '0.5';
        }
        setupHandlingTypeControl();
        setupButtons();
        endLoadingDisplay();
    }
    catch (error) {
        console.error('差戻修正画面の初期化に失敗しました:', error);
        endLoadingDisplay();
        throw error;
    }
};
